import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { globalValueSetStepper } from "states/global-value/global-value.action";
import { Stepper } from "states/global-value/global-value.models";
import { RootState } from "../../app.store";
import { AddressComponent } from "./address-component";
import { CouponComponent } from "./coupon";
import { ItemProductComponent } from "./item-product";
import { SummaryComponent } from "./summary";
import "./cart.less";
const Cart = () => {
  const dispatch = useDispatch();
  const model = useSelector((state: RootState) => state.cart, shallowEqual);
  useEffect(() => {
    document.title = "Giỏ hàng";
    dispatch(globalValueSetStepper(Stepper.Cart));
  }, []);
  return ( model ?
    <div className="flex-container shopping-cart-container">  
      <div className="cart-container">
        {model.shoppingCartItems.length > 0 ?
          model.shoppingCartItems.map((item) => (
            <ItemProductComponent key={item.skuId} orderItem={item} />
          )): <p className="text-warning-cart">Giỏ hàng trống vui lòng thêm sản phẩm vào giỏ hàng.</p>}
      </div>
      <div className="info-container">
        {model.address && (
          <AddressComponent
          address={model.address}
          email={model.email}
          districtName={model.districtName}
          provinceName={model.provinceName}
          wardName={model?.wardName}
          phone={model.shipPhoneNumber}
          name={model.shipName}
        />
        )}
        <CouponComponent  coupon={model.couponCode} />
        <SummaryComponent
            total={model.totalAmount}
            discount={model.discountAmount}
            subTotal={model.subTotalAmount}
            shippingFee={model.shippingFee}
          />
      </div>
    </div>
  : null);
};
export default Cart;
